import { writable } from 'svelte/store';
export const BID_STORE = writable({});
export const BID_HASH = writable('initial');
